import { render, staticRenderFns } from "./UcSuggestInvoiceOption.yaml?vue&type=template&id=78f5090d&component"
import script from "./UcSuggestInvoiceOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestInvoiceOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports